import script from "./QuestionAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionAnswer.vue?vue&type=script&setup=true&lang=js"

import "./QuestionAnswer.vue?vue&type=style&index=0&id=7c446372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c446372"]])

export default __exports__